import { addDataLayer } from './addDataLayer'

// @TODO: refactor: I know it's not the best solution, but I don't have time to refactor it now.
const basicNutritionalValuesFieldsDataLayer = {
	'nutritionalValues.nv-01': 'carbohydrates',
	'nutritionalValues.nv-02': 'protein',
	'nutritionalValues.nv-03': 'fats',
	'nutritionalValues.nv-04': 'moisture',
	'nutritionalValues.nv-05': 'ash',
	'nutritionalValues.nv-06': 'fibre',
}
const pricesAndPackKeysFieldsDataLayer = {
	prices: 'package_price',
	weights: 'pack_size ',
	czk_per_metabolized_energy: 'dose_price',
}
type BasicNutritionalValuesFieldsDataLayer = keyof typeof basicNutritionalValuesFieldsDataLayer
type PricesAndPackKeysFieldsDataLayer = keyof typeof pricesAndPackKeysFieldsDataLayer

export const addDataLayerRangeFilter = (field: string, min: number, max: number) => {
	if (field in pricesAndPackKeysFieldsDataLayer) {
		const currentField = field as PricesAndPackKeysFieldsDataLayer
		addDataLayer([
			{
				event: 'filtering',
				eventLabel: {
					eventCategory: 'Filtering',
					filterCategory: 'price_packing',
					filterLabel: pricesAndPackKeysFieldsDataLayer[currentField],
					minSet: min,
					maxSet: max,
				},
			},
		])
	} else if (field in basicNutritionalValuesFieldsDataLayer) {
		const currentField = field as BasicNutritionalValuesFieldsDataLayer
		addDataLayer([
			{
				event: 'filtering',
				eventLabel: {
					eventCategory: 'Filtering',
					filterCategory: 'basic_nutrients',
					filterLabel: basicNutritionalValuesFieldsDataLayer[currentField],
					minSet: min,
					maxSet: max,
				},
			},
		])
	}
	// @TODO: add next
}
